import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const getAllLeaves = async (filters = {}) => {
  const res = await axiosInstance.get("/leaves/all", { params: filters });
  return res.data;
};

export const getLeaveById = async (id) => {
  const res = await axiosInstance.get(`/leaves/${id}`);
  return res.data;
};

export const approveLeave = async (id, data) => {
  const res = await axiosInstance.put(`/leaves/approve/${id}`, data);
  return res.data;
};

export const rejectLeave = async (id, data) => {
  const res = await axiosInstance.put(`/leaves/reject/${id}`, data);
  return res.data;
};